'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddToCartButton = exports.CLASS_SUCCESS = exports.CLASS_DISABLED = exports.ADD_NOTIFICATION = exports.ADD_BUTTON = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _pcSlateTools = require('@process-creative/pc-slate-tools');

var _VariantSelector = require('./../variant/VariantSelector');

var _Recharge = require('./Recharge');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ADD_BUTTON = exports.ADD_BUTTON = '[data-add-to-cart-button]';
// import { generateLoader } from './../loader/Loader';
/*
 *  Add To Cart Button
 *    Contains scrits for add to cart button for product templates
 *
 *  Version:
 *    1.0.0 - 2020/07/06
 */

var ADD_NOTIFICATION = exports.ADD_NOTIFICATION = '[data-add-to-cart-notification]';

var CLASS_DISABLED = exports.CLASS_DISABLED = 'is-disabled';
var CLASS_SUCCESS = exports.CLASS_SUCCESS = 'is-success';

var AddToCartButton = exports.AddToCartButton = function () {
  function AddToCartButton(template, container, product) {
    var _this = this;

    (0, _classCallCheck3.default)(this, AddToCartButton);

    this.template = template;
    this.container = container;
    this.cartPending = false;

    //Elements
    this.button = container.find(ADD_BUTTON);
    this.notification = container.find(ADD_NOTIFICATION);
    this.recharge = new _Recharge.Recharge(product.find(_Recharge.RECHARGE_OPTIONS_CONTAINER));

    $(document).on(_VariantSelector.ON_VARIANT_CHANGE, function (e, variant) {
      return _this.useVariant(variant);
    });
    container.on('click', ADD_BUTTON, function (e) {
      return _this.onAddClick(e);
    });

    this.useVariant(this.getVariantData());
  }

  (0, _createClass3.default)(AddToCartButton, [{
    key: 'getVariantData',
    value: function getVariantData() {
      var vs = this.template.swatches || this.template.variantSelector;
      return vs.getVariantData();
    }
  }, {
    key: 'updateButton',
    value: function updateButton(variant, id) {
      //Adjust the add to cart button based on QTY available and in cart
      var available = variant.available,
          inventory_policy = variant.inventory_policy,
          inventory_management = variant.inventory_management,
          inventory_quantity = variant.inventory_quantity;

      var inCart = (0, _pcSlateTools.getCountOfVariantInCart)(id);

      this.button.removeClass(CLASS_SUCCESS);

      if (available) {
        if (inventory_policy != 'continue' && inventory_management != null && inventory_quantity - inCart <= 0) {
          available = false;
          this.button.html('' + (0, _pcSlateTools.t)('products.product.all_in_cart'));
          this.button.attr('disabled', 'disabled');
          this.button.addClass(CLASS_DISABLED);
        } else {
          this.button.html('' + (0, _pcSlateTools.t)('products.product.add_to_cart'));
          this.button.removeAttr('disabled', 'disabled');
          this.button.removeClass(CLASS_DISABLED);
        }
      } else {
        this.button.html('' + (0, _pcSlateTools.t)('products.product.sold_out'));
        this.button.attr('disabled', 'disabled');
        this.button.addClass(CLASS_DISABLED);
      }
    }
  }, {
    key: 'useVariant',
    value: function useVariant(variant) {
      if (this.cartPending) return; //Don't update the button if the cart is pending
      var id = variant.id;

      this.updateButton(variant, id);
    }
  }, {
    key: 'onCartPending',
    value: function onCartPending() {
      this.cartPending = true;

      this.button.addClass('is-disabled');
      this.button.attr('disabled', 'disabled');
      // this.button.html(generateLoader(null, null, null, 16));
    }
  }, {
    key: 'onCartFinished',
    value: function onCartFinished() {
      this.cartPending = false;
      this.useVariant(this.getVariantData());
    }
  }, {
    key: 'onAddClick',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        var _this2 = this;

        var id, variant, discount_variant_id, originalUrl, props, rechargeProps;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                e.stopPropagation();
                id = this.getVariantData().id;
                variant = this.getVariantData(id);
                discount_variant_id = variant.discount_variant_id;
                originalUrl = variant.product.url;

                //Build line item props

                props = {};
                rechargeProps = {};

                //Is this a reCharge product? If so build the recharge props &&
                //change the variant to add to cart

                if (this.recharge.isRechargeSelected() && discount_variant_id) {
                  id = discount_variant_id;
                  rechargeProps.shipping_interval_frequency = this.recharge.getSelectedFrequency();
                  rechargeProps.shipping_interval_unit_type = this.recharge.getFrequencyUnit();
                  rechargeProps._original_product_url = originalUrl;
                  rechargeProps.subscription_id = id;
                }

                props = Object.assign({}, props, rechargeProps);

                if (!this.button.hasClass(CLASS_DISABLED)) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt('return');

              case 12:
                _context.prev = 12;

                this.button.html('' + (0, _pcSlateTools.t)('products.product.cart_pending'));
                _context.next = 16;
                return (0, _pcSlateTools.addToCart)(id, this.template.quantitySelector.getValue(), props);

              case 16:
                this.wasAdded = true; //This will tell our button to temporarily display the "Was added" text
                _context.next = 24;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](12);

                console.error(_context.t0);
                if (_context.t0.description) alert(_context.t0.description);
                return _context.abrupt('return');

              case 24:

                this.button.html('' + (0, _pcSlateTools.t)('products.product.added_to_cart'));
                this.button.addClass(CLASS_SUCCESS);
                setTimeout(function () {
                  return _this2.updateButton(variant, id);
                }, 5000);

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[12, 19]]);
      }));

      function onAddClick(_x) {
        return _ref.apply(this, arguments);
      }

      return onAddClick;
    }()
  }]);
  return AddToCartButton;
}();